import { ZipCoverageMapSelections, ZipCoverageSelectedServiceArea } from "@app/projects/zip-projects/maps/interfaces";

export const isMultiZipSelection = (selections: ZipCoverageMapSelections | null): boolean =>
  (selections?.serviceAreas?.length ?? 0) > 1;

export const getSelectedZipCodes = (selections: ZipCoverageMapSelections | null): string[] =>
  selections?.serviceAreas?.map((area) => area.zipCode) ?? (selections ? [selections.serviceArea.zipCode] : []);

// Stands in for the single zip in the labels and titles that read `serviceArea`, so they describe the whole selection.
export const buildMultiZipServiceArea = (areas: ZipCoverageSelectedServiceArea[]): ZipCoverageSelectedServiceArea => {
  const stateNames = new Set(areas.map((area) => area.stateName));
  return {
    ...areas[0],
    countyName: undefined,
    label: `${areas.length.toLocaleString()} Zip Codes`,
    stateName: stateNames.size === 1 ? areas[0].stateName : undefined,
  };
};
